









































import TableComp from '@/components/Common/TableComp.vue';
import CommonIconBtn from '@/components/Common/CommonIconBtn.vue'
import TableOperaBtn from '@/components/Common/TableOperaBtn.vue';
import { Component, Vue } from 'vue-property-decorator';
import { getAgentDatasApi } from '@/api/company';
import { debounce } from '@/utils/function_utils';

@Component({
  name: 'subcompanyList',
  components: {
    TableComp,
    TableOperaBtn,
    CommonIconBtn,
  }
})
export default class extends Vue {
  public tableData: any = [];

  // 利用防抖避免连续多次点击发送多次请求
  public getTables = debounce(this.getTableDatas, 500);

  // public created() {
  //   this.getTables();
  // }

  public async getTableDatas() {
    const { data } = await getAgentDatasApi();
    this.tableData = data.datas;
  }

}
